module.exports = ".select-list {\n  position: absolute;\n  z-index: 4;\n  list-style-type: none;\n  padding: 10px;\n  margin: 5px 0 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/order-incress-time/order-incress-time.component.scss
// module id = ./src/app/dashboard/order-incress-time/order-incress-time.component.scss
// module chunks = main